"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgEllipse = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 4, height: 4, fill: "none" }, props),
    React.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "#BFBFBF" })));
const Memo = (0, react_1.memo)(SvgEllipse);
exports.default = Memo;
//# sourceMappingURL=Ellipse.js.map